var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{staticClass:"tiny"},[_c('tiny-editor-component',{attrs:{"init":_vm.tinyInit},model:{value:(_vm.messageContentSynced),callback:function ($$v) {_vm.messageContentSynced=$$v},expression:"messageContentSynced"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }